import QTable from 'quasar/src/components/table/QTable.js';

export function getContentItemColumnsInAdmin(): QTable['columns'] {
  return [
    {
      name: 'id',
      field: 'id',
      label: '#',
      align: 'left'
    },
    {
      name: 'main_keyword',
      field: 'main_keyword',
      label: 'کلمه کلیدی',
      align: 'left',
      style: 'max-width: 150px'
    },
    {
      name: 'status',
      field: 'status',
      label: 'وضعیت',
      align: 'left'
    },
    {
      name: 'editor',
      field: 'editor',
      label: 'ویراستار',
      align: 'center',
      style: 'max-width: 120px'
    },
    {
      name: 'deliver_at',
      field: 'deliver_at',
      label: 'تاریخ تحویل',
      align: 'center'
    },
    {
      name: 'register_at',
      field: 'register_at',
      label: 'تاریخ ثبت',
      align: 'center'
    },
    {
      name: 'writer',
      field: 'writer',
      label: 'نویسنده',
      align: 'left'
    },
    {
      name: 'actions',
      field: 'actions',
      label: '',
      align: 'right'
    }
  ]
}

export function getContentItemColumnsInPanel(hasStep: boolean = true): QTable['columns'] {

  return [
    {
      name: 'id',
      label: 'شماره مقاله',
      field: 'id',
      align: 'left'
    },
    {
      name: 'title',
      label: 'عنوان مقاله',
      field: 'title',
      align: 'left',
      style: 'max-width:250px;min-width:150px'
    },
    {
      name: 'main_keyword',
      field: 'main_keyword',
      label: 'کلمه کلیدی',
      align: 'left',
      style: 'max-width: 250px'
    },
    //@ts-ignore
    (hasStep)
      ? {
        name: 'step',
        label: 'مرحله',
        field: 'step',
        align: 'left'
      }
      : {},
    {
      name: 'status',
      label: 'وضعیت',
      field: 'status',
      align: 'left'
    },
    {
      name: 'content_type',
      label: 'نوع محتوا',
      field: 'content_type',
      align: 'left'
    },
    {
      name: 'deliver_at',
      label: 'تاریخ تقریبی تحویل',
      field: 'deliver_at',
      align: 'center'
    },
    {
      name: 'actions',
      label: '',
      field: 'actions',
      align: 'right'
    }
  ]

}
